import { Suspense, lazy } from "react";
import DashboardLayout from "../layouts/dashboard";
import { PATH_FUNNELS } from "./paths";
import { Outlet } from "react-router-dom";
import AuthGuard from "../guards/AuthGuard";
import RoleGuard from "@/guards/RoleGuard";

const FunnelsContainer = lazy(() => import("@/pages/funnels/funnels.container"));

const funnelRoutes = [
    {
        path: PATH_FUNNELS,
        element: (
            <AuthGuard>
                <RoleGuard>
                    <DashboardLayout>
                        <Suspense>
                            <Outlet />
                        </Suspense>
                    </DashboardLayout>
                </RoleGuard>
            </AuthGuard>
        ),
        children: [
            {
                element: <FunnelsContainer />,
                index: true,
            },
        ],
    },
];

export default funnelRoutes;
